import React, { useEffect, useState } from "react";
import { Grid, TableCell, TableRow } from "@mui/material";
import TableDesign from "../../../../components/common/table/TableDesign";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import {
  getStorageLogList,
  setStorageResponse,
  setUpdateStorageResponse,
} from "../../../../store/reducers/storageSlice";

interface StorageLogListProps {
  leadId: string | null;
}

const StorageLogList: React.FC<StorageLogListProps> = ({ leadId }) => {
  const dispatch = useDispatch();
  const {
    storageLogLists,
    storageLogListPagination,
    storageLogRefreshVersion,
    response,
  } = useSelector((state: any) => state.storage);
  const [filterOption, setFilterOption] = useState({
    page: 1,
    limit: 10,
    orderBy: "created_at",
    orderIn: "DESC",
  });

  useEffect(() => {
    if (leadId && filterOption)
      dispatch(
        getStorageLogList({
          ...filterOption,
          leadId: leadId,
          contractId: "",
        }),
      );
  }, [dispatch, leadId, filterOption, storageLogRefreshVersion]);

  useEffect(() => {
    if ((response?.addStorage || response?.updateStorage) && leadId) {
      dispatch(
        getStorageLogList({
          ...filterOption,
          leadId: leadId,
          contractId: "",
        }),
      );
      if (response?.addStorage) {
        dispatch(setStorageResponse(false));
      }
      if (response?.updateStorage) {
        dispatch(setUpdateStorageResponse(false));
      }
    }
  }, [
    dispatch,
    filterOption,
    leadId,
    response?.addStorage,
    response?.updateStorage,
  ]);
  

  const tableHeadings: {
    label: string;
    align: "center" | "left" | "right" | undefined;
  }[] = [
    { label: "User", align: "center" },
    { label: "Created On", align: "left" },
    { label: "Time", align: "left" },
    { label: "Action", align: "left" },
  ];

  return (
    <Grid container spacing={1} sx={{ marginLeft: "0px", marginTop: "0px" }}>
      <Grid
        item
        md={12}
        xs={12}
        sx={{ padding: "0px !important", border: "1px solid #d1cfcf" }}
      >
        <TableDesign
          tableHeadColor="#e5f4f1"
          tableHeadings={tableHeadings}
          pagination={storageLogListPagination}
          isLoader={false}
          filterOption={filterOption}
          setFilterOption={setFilterOption}
        >
          {storageLogLists.length > 0 ? (
            storageLogLists.map((val: any, idx: number) => (
              <TableRow
                key={idx}
                sx={{
                  backgroundColor: idx % 2 === 1 ? "#eeecf0" : "none",
                }}
              >
                <TableCell align="center" style={{ padding: "0px" }}>
                  {val?.actorName}
                </TableCell>
                <TableCell>
                  {dayjs(val?.createdAt).format("DD/MM/YYYY")}
                </TableCell>
                <TableCell>{dayjs(val?.createdAt).format("HH:mm")}</TableCell>
                <TableCell>{val?.action}</TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={tableHeadings.length} align="center">No Data Found!</TableCell>
            </TableRow>
          )}
        </TableDesign>
      </Grid>
    </Grid>
  );
};

export default StorageLogList;
